import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './styles/fonts';
import './styles/globals.css';
import { App } from './App';

/**
 * Client entry.
 *
 * Most routes are prerendered to real HTML (scripts/prerender.ts), so in
 * production this hydrates. Two cases have no markup to hydrate and must render
 * fresh instead:
 *
 *   - `npm run dev`, which serves the bare index.html template;
 *   - routes flagged clientOnly in lib/seo.ts, whose root is emitted empty.
 *
 * The test is firstElementChild rather than hasChildNodes(): in dev the root
 * still contains the `<!--app-html-->` placeholder, and a comment is a child
 * node, so hasChildNodes() is true and hydration is attempted against markup
 * that was never rendered.
 */
const container = document.getElementById('root')!;

const tree = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

if (container.firstElementChild) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
